import { Directive, Input } from '@angular/core';
import { ZippyOpenDirective } from '@df/legacy/ui/zippy/zippy-open.directive';

@Directive({
    selector: '[zippyClose]',
    standalone: false
})
export class ZippyCloseDirective extends ZippyOpenDirective {
    /**
     * Zippy name setter
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     */
    @Input()
    set zippyClose(name: string | (string | number)[]) {
        this.parseName(name);
    }

    /**
     * Click event listener
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     */
    override onClick() {
        if (this.client.isCms || this.isOnClick) {
            this.close();
        }
    }

    /**
     * Mouseover event listener.
     *
     * @param  {[type]} 'mouseenter'
     */
    protected override onMouseIn() {
        if (!this.client.isCms && this.isOnHover) {
            this.clear();
            this.timeoutService.setTimeout(() => this.close(), this.outDelay);
        }
    }
}
